// extracted by mini-css-extract-plugin
module.exports = {"back":"FiltersModalHead_back__BShpe","head":"FiltersModalHead_head__4Se2E"};